
















import { EVENTS, GETTERS_KEYS, SUBMODULES_PATHS } from '@empathybroker/ebx-gluon';
import type { EmpathyXConfig, TrackClickEvents } from '@empathybroker/ebx-gluon';
import DefaultPromoted from '@empathybroker/ebx-gluon/dist/components/pure/default-promoted.vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

const DefaultPromotedTrackingClickEvents: TrackClickEvents = {
  click: EVENTS.PromotedClicked,
  rightClick: EVENTS.PromotedRightClicked
};

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.config, ['device']),
    ...mapGetters({
      config: GETTERS_KEYS.config.config
    }),
    ...mapGetters({
      showPartials: GETTERS_KEYS.search.showPartials
    })
  }
})
export default class CdlPromoted extends DefaultPromoted {
  @Prop({ default: () => DefaultPromotedTrackingClickEvents })
  clickEvents: TrackClickEvents;

  config: EmpathyXConfig;
  device: string;
  showPartials: boolean;

  get isMultiColumnLayout(): boolean {
    return !this.showPartials && this.config.resultsGrid.grid.columns > 1 && this.device === 'desktop';
  }
}
